import { z } from "zod";

export const ExtraCreditsBenefitType = z.literal("EXTRA_CREDITS");

export const ExtraCreditsCouponConfigDto = z.object({
  type: ExtraCreditsBenefitType,
  multiplier: z.number(),
  planTypes: z.array(z.enum(["SUBSCRIPTION", "ONE_OFF"])),
  campaignTitle: z.string().optional(),
});

export const DfyDiscountCouponConfigDto = z.object({
  type: z.literal("DFY_DISCOUNT"),
  credits: z.number(),
});

export const CouponConfigDto = z.discriminatedUnion("type", [
  ExtraCreditsCouponConfigDto,
  DfyDiscountCouponConfigDto,
]);

export const CouponDto = z.object({
  code: z.string(),
  expiresAt: z.string().nullable(),
  config: ExtraCreditsCouponConfigDto,
});

export const DfyCouponDto = z.object({
  code: z.string(),
  credits: z.number(),
});

export type ExtraCreditsBenefitType = z.infer<typeof ExtraCreditsBenefitType>;
export type ExtraCreditsCouponConfigDto = z.infer<
  typeof ExtraCreditsCouponConfigDto
>;
export type DfyDiscountCouponConfigDto = z.infer<
  typeof DfyDiscountCouponConfigDto
>;
export type CouponConfigDto = z.infer<typeof CouponConfigDto>;
export type CouponDto = z.infer<typeof CouponDto>;
export type DfyCouponDto = z.infer<typeof DfyCouponDto>;
